module.exports = __webpack_public_path__ + "static/img/case1.126d83e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case1.jpg?20181011
// module id = RpAY
// module chunks = 1